import React from 'react'

import { B2, Stack, XStack } from '@zet/design-system'

type Props = {
  icon: React.ReactNode
  name: string
  value: string | null
}

const PaymentDetailsItem = (props: Props) => {
  const { icon, name, value } = props
  return (
    <XStack className="mx-4 mb-5">
      <Stack className="mr-3 w-4 justify-center">{icon}</Stack>
      <Stack>
        <B2 className="text-grays-70">{name}</B2>
        <B2 className="text-grays-80">{value}</B2>
      </Stack>
    </XStack>
  )
}

export default PaymentDetailsItem
